var map = {
	"./6Q4A5228-Enhanced-NR.jpg": 5924,
	"./6Q4A5341.jpg": 2790,
	"./6Q4A5473-Enhanced-NR.jpg": 2014,
	"./6Q4A5520-Enhanced-NR.jpg": 9215,
	"./REAL2.jpg": 6403,
	"./REAL3.jpg": 7878,
	"./REAL4.jpg": 5677,
	"./REAL6.jpg": 9087,
	"./REAL7.jpg": 6418,
	"./REAL_PHOTO1.jpg": 7987,
	"./real8a.jpg": 9832,
	"./real9.jpg": 2412,
	"./εικόνα_Viber_2025-03-08_17-59-51-029.jpg": 946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3290;